<template lang="pug">
section.src-components-datepicker
  v-menu(ref='menu' v-model='menu' :close-on-content-click='false' :return-value.sync='date' transition='scale-transition' offset-y='' min-width='auto')
    template(v-slot:activator='{ on, attrs }')
      v-text-field(v-model='dateFormatted' :label='label' prepend-icon='mdi-calendar' readonly='' v-bind='attrs' v-on='on' @blur='date = parseDate(dateFormatted)')
    v-date-picker(v-model='date' no-title='' scrollable='' @click:date='save(date)' locale="es-ES")
      v-spacer
      v-btn(text='' color='primary' @click='menu = false')
        | Cancel
      v-btn(text='' color='primary' @click='save(date)')
        | OK

</template>

<script lang="js">

  export default  {
    name: 'src-components-datepicker',
    props: ['label','v-model'],
    mounted () {
      if (this.startDate) {
        this.date = this.startDate
      }
      this.dateFormatted = this.formatDate(this.date)
    },
    data () {
      return {
        dateFormatted:"",
        menu:false,
        date:this['v-model'],
      }
    },
    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(val)
      },
    },
    methods: {
      save(date){
        //this['v-model']=this.date
        this.$refs.menu.save(date)
        this.$emit('date', this.date)
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [day,month,year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
    },
}


</script>

<style scoped lang="scss">
  .src-components-datepicker {

  }
</style>
